import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/hooks";
import { clearSearchStudents, searchStudents } from "../../redux/StudentsSlice";

export const StudentSearchBar = ({ dataForFiltered }: any) => {
  // define text ref
  const text: any = useRef(null);
  const dispatch = useAppDispatch();
  const student = useAppSelector((state) => state.student);

  useEffect(() => {
    if (student.filtered === null || text.current.value === "") {
      text.current.value = "";
      dispatch(clearSearchStudents());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student.filtered]);

  const onChange = (e: any) => {
    if (text.current.value !== "") {
      const regex = new RegExp(`${text.current?.value}`, "gi");
      const dataFitered = dataForFiltered.filter((students: any) => {
        if (students.person) {
          return (
            students.person.nom.match(regex) ||
            students.person.prenom.match(regex) ||
            students.code.match(regex)
          );
        } else {
          return (
            students.nom.match(regex) ||
            students.prenom.match(regex) ||
            students.code.match(regex)
          );
        }
      });
      dispatch(searchStudents(dataFitered));
    } else {
      dispatch(clearSearchStudents());
    }
  };
  return (
    <>
      <div className=' col-md-6 mb-2'>
        <form>
          <label htmlFor='inputPassword2' className='visually-hidden'>
            Search
          </label>
          <input
            type='search'
            className='form-control'
            placeholder='Rechercher  etudiant...'
            ref={text}
            onChange={onChange}
          />
        </form>
      </div>
    </>
  );
};
